import { FunctionComponent, ReactElement } from "react";
import { Input, InputProps } from "@App/Components/common/Input";
import { InputLabel, InputLabelProps } from "@App/Components/atoms/common/InputLabel";
import { InputHint, InputHintProps } from "@App/Components/atoms/common/InputHint";

type AllowedChild =
  | ReactElement<InputLabelProps, typeof InputLabel>
  | ReactElement<InputHintProps, typeof InputHint>
  | ReactElement<InputProps, typeof Input>;

type FieldProps = {
  children?: AllowedChild | AllowedChild[];
};

/**
 * Field component to wrap input elements. Currently, it does nothing, it's just here for future proofing.
 *
 * @param children
 * @constructor
 */
export const Field: FunctionComponent<FieldProps> = ({ children }: FieldProps) => {
  return <>{children}</>;
};
